import type { LessonOptionSessionType, LessonOptionSummaryResponse } from '../models/LessonOption';

export type LessonOptionDuplicatePayload = {
  name: string;
  description?: string | null;
  durationMinutes: number;
  price: number;
  currencyCode: string;
  sessionType: LessonOptionSessionType;
  assignedTutorIds: string[];
};

export type LessonOptionDuplicateLocationState = {
  duplicateFrom: LessonOptionDuplicatePayload;
};

/** Unique copy name for the same session type (case-insensitive). */
export const nextLessonOptionCopyName = (
  baseName: string,
  sessionType: LessonOptionSessionType,
  existing: Pick<LessonOptionSummaryResponse, 'name' | 'sessionType'>[]
): string => {
  const used = new Set(
    existing
      .filter((option) => option.sessionType === sessionType)
      .map((option) => option.name.trim().toLocaleLowerCase())
  );
  const base = baseName.trim() || 'Lesson option';
  let candidate = `${base} (copy)`;
  let index = 2;
  while (used.has(candidate.toLocaleLowerCase())) {
    candidate = `${base} (copy ${index})`;
    index += 1;
  }
  return candidate;
};
